import { useEffect, useState } from 'react';

import { useUIState } from '@hotjar/webapp/features/Core/hooks/useUIState';
import { useShortLinkWidgetHiddenState } from '@hotjar/webapp/features/ShortLinkWidget';

export function NoAppInterfaceRoute({ children }: { children: React.ReactNode }): JSX.Element {
  const { setIsAppInterfaceVisible, isAppInterfaceVisible } = useUIState();
  const [initial] = useState(isAppInterfaceVisible);
  // Not too sure this is the right place, but we do need to remove the short link widget as it overlaps on fullscreen footers
  // hiding it in the NoAppInterface made sense at the time
  const { setIsHidden: setIsShortLinkWidgetHidden } = useShortLinkWidgetHiddenState();

  useEffect(() => {
    setIsAppInterfaceVisible(false);
    setIsShortLinkWidgetHidden(true);
    return () => {
      setIsAppInterfaceVisible(initial);
      setIsShortLinkWidgetHidden(false);
    };
  }, [setIsAppInterfaceVisible, initial, setIsShortLinkWidgetHidden]);

  return <>{children}</>;
}
